<template>
    <metainfo>
        <template #title="{ content }">
            {{ content }}
        </template>
    </metainfo>

    <router-view />

    
</template>

<script setup>
    import { useMeta } from 'vue-meta';
    import { inject, onMounted, watch } from 'vue';

    import usePreloadApp from 'root-js/plugins/VuePreloader/composables/usePreloadApp';
    import Backdrop from 'root-js/components/common/Backdrop.vue';
    import bus from 'root-js/services/BusService';
    import { useMinimumIosVersionCheck } from './composables/useMinimumIosVersionCheck';
    import store from 'root-js/store';
    import { registerListenersAndSyncIfGranted } from 'root-js/services/PushNotificationService';
import { syncIfGrantedForCurrentUser } from './services/PushNotificationService';

    const config = inject('$config');
    const { checkMinimumIosVersion } = useMinimumIosVersionCheck();

    // Set the default meta information
    useMeta({ title: config.app.meta.title });

    // Preload the app
    usePreloadApp();

    // Automatically initialize push notifications and sync tokens when the user is logged in
    watch(() => store.getters['auth/token'], (token) => {
        
        if (token) {
            
            registerListenersAndSyncIfGranted();
            syncIfGrantedForCurrentUser()
        }
    }, { immediate: true });

     onMounted(() => {
        store.dispatch('appConfig/FETCH_CONFIG').catch(err => console.error('Failed to pre-fetch config', err));
        store.dispatch('store/GET_PRODUCTS').catch(err => console.error('Failed to pre-fetch products', err));
        bus.on('app-ready', () => {
            void checkMinimumIosVersion();
        });
    });
</script>
